import { Component, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import commonStore from '../../stores/common.store';
import formStore from '../../stores/form.store';
import { ClickOutside } from '../on-click-outside/on-click-outside';

@Component({
  tag: 'app-preview-record-modal',
  styleUrl: 'preview-record-modal.scss',
  shadow: true,
})
export class PreviewRecordModal {
  private close(): void {
    commonStore.state.displayVideoPreview = false;
  }

  // eslint-disable-next-line @stencil-community/own-methods-must-be-private
  @ClickOutside()
  tryToClose() {
    this.close();
  }

  render() {
    return (
      <Host>
        <div class="preview-record-modal">
          <div
            class="preview__close"
            onClick={() => this.close()}
          >
            <img
              src={getAssetPath('./../assets/images/cross.svg')}
              alt={wcShared.translate('Fermer')}
            />
          </div>
          <div class="preview__title">{wcShared.translate('Previsualisation du media')}</div>
          <div class="preview__separator"></div>
          <div class="preview__media">
            {commonStore.state.isImagePreview ? (
              <img
                src={formStore.printScreen}
                alt="preview"
              />
            ) : (
              <video
                src={formStore.recordedVideo}
                controls
              ></video>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
